import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, query, updateDoc, where } from 'firebase/firestore';
import { db } from '../config/firebase';

const activityTypesCollection = collection(db, "activity_types");

const activityTypeService = { 
  getAll: async () => {
    try {  
      const activityTypesSnapshot = await getDocs(activityTypesCollection);
      const activityTypesList = activityTypesSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      return activityTypesList;
    } catch (error) {
      console.error('Error fetching activity types:', error);
      throw error;
    }
  },
  add: async (activityTypesData) => {
    try {
      const docRef = await addDoc(activityTypesCollection, activityTypesData);
      return docRef;
    } catch (error) {
      console.error('Error adding activity types:', error);
      throw error;
    }
  },
  edit: async ({ id, data }) => {
    try {
      const activityTypeRef = doc(db, 'activity_types', id);
      await updateDoc(activityTypeRef, data);
    } catch (error) {
      console.error('Error updating activity types:', error);
      throw error;
    }
  },
  delete: async (activityTypeId) => {
    try {
     await deleteDoc(doc(db, "activity_types", activityTypeId));
     return true;
    } catch (error) {
      console.error('Error deleting activity types:', error);
      throw error;
    }
  },

  getNameById: async (activityTypeId) => {
    try {
     const activityTypeRef = doc(db, 'activity_types', activityTypeId);
     const activityTypeSnap = await getDoc(activityTypeRef);

     if (activityTypeSnap.exists()) {
       return activityTypeSnap.data().name;  
     }
     else {
       return null; 
     }
    } 
    catch (error) {
      console.error('Error getting activity Type name:', error);
      throw error; 
    }
  },
  getSpendTypeActivityTypes: async (spendTypeId) => {
    try {
      const querySnapshot = await getDocs(
        query(activityTypesCollection, where("spend_type_id", "==", spendTypeId))
      ); 
      const activityTypes = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(), 
      }))
    
      return activityTypes;
    } 
    catch (error) {
      console.error("Error getting activity types:", error);
      throw error; 
    }
  },

};

export default activityTypeService;


